import React from 'react';
import { node } from 'prop-types';

import Head from '../Head';
import Footer from '../Footer';

/**
 * Componente que genera el Layout
 *
 * @component
 * @param {import('../../interfaces/containers/layout.interface').LayoutProps} props - Propiedades del componente
 * @returns {React.ReactElement} - Devuelve un componente Layout
 */
export default function Layout({ children }) {
  return (
    <div className="o-layout">
      <Head />
      <div className="o-layout__body">
        <main className="o-layout__main">{children}</main>
      </div>
      <Footer />
    </div>
  );
}

Layout.propTypes = {
  children: node.isRequired,
};
